module.exports = __webpack_public_path__ + "img/logo_level-next_primary_white.58289ce8.svg";